<template>
        <global-dropdown :options="filter.options" :initial-title="filter.title" :disabled="filterDisabled(filter.options)" @change="onSelectionChange" :multi-select="true" :theme="theme" />
</template>

<script lang="ts">
import GlobalDropdown from "../global-dropdown/global-dropdown.vue";
import {defineComponent, PropType} from 'vue'
import {GlobalFilterOptionType, GlobalFilterType} from "../global-filter/GlobalFilterType";

export default defineComponent({
        components: {GlobalDropdown},
        name: "global-filter-select",
        props: {
            filter: {
                type: Object as PropType<GlobalFilterType>,
                required: true
            },
            theme: {
                type: String as PropType<"sustain" | "secondary">,
                default: "secondary"
            }
        },
        methods: {
            onSelectionChange(changedOption: GlobalFilterOptionType) {
                this.$emit('changeOption', {
                    filterName: this.filter.name,
                    optionName: changedOption.key
                })
            },
            filterDisabled(options: GlobalFilterOptionType[]) {
                return !options.some(option => !option.disabled);
            },
        }
    })
</script>
